import { render, staticRenderFns } from "./Exception02.vue?vue&type=template&id=037203fb&scoped=true&"
import script from "./Exception02.vue?vue&type=script&lang=js&"
export * from "./Exception02.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037203fb",
  null
  
)

export default component.exports